"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInvoice = void 0;
const react_1 = require("react");
const InvoiceContext_1 = require("./InvoiceContext");
const useInvoice = () => {
    const context = (0, react_1.useContext)(InvoiceContext_1.InvoiceContext);
    if (!context)
        throw new Error('useInvoice must be used within a InvoiceProvider');
    return context;
};
exports.useInvoice = useInvoice;
